import { cx } from '@linaria/core';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import { useEffect, useRef, useState } from 'react';
import { headerSearch } from '../../../actions/search';
import { GatedDisplayModes, SecureStateType } from '../../../constants/enums';
import { MAX_SEARCH_QUERIES_STORED } from '../../../constants/search';
import { isLevelBasicOrHigher, isLevelModel, isLevelPremium } from '../../../mfcLogic/userProperties/level';
import { openAgeGateDialog } from '../../../state/modals/state.dialog';
import { openAccountDrawer, openAuthenticationDrawer, openSignupDrawer, openTokensDrawer } from '../../../state/modals/state.drawer';
import { updateLayoutState } from '../../../state/state.layout';
import { AppRouter } from '../../../state/state.router';
import { setScreenOrientation } from '../../../state/state.screen';
import { deleteSearchQueryExternal, resetSearchQuery, resetSearchResults } from '../../../state/state.search';
import { toggleSidebarVisibility } from '../../../state/state.sidebar';
import ButtonBuy from '../../Buttons/ButtonBuy';
import ButtonMenu from '../../Buttons/ButtonMenu';
import ButtonSidebar from '../../Buttons/ButtonSidebar';
import ButtonUserBroadcast from '../../Buttons/ButtonUserBroadcast';
import IconButton from '../../Buttons/IconButton';
import { AppStateType, useAppState } from '../../Hooks/useAppState';
import DarkModeToggle from '../../common/DarkModeToggle';
// import { useSearch } from '../../Hooks/useSearch'
import { transitionNavLayout } from '../../../actions/layout';
import { goToMail } from '../../../actions/nav';
import { locales } from '../../../locales/en';
import { isIDevice, isPWA } from '../../../utilities/browser';
import { routerPush } from '../../../utilities/router';
import Button from '../../Buttons/Button';
import { useLayoutSelector } from '../../Hooks/useLayout';
import { useMailStateSelector } from '../../Hooks/useMail';
import { useRouteSelector } from '../../Hooks/useRoute';
import { useScreenStateSelector } from '../../Hooks/useScreenState';
import { useSearch } from '../../Hooks/useSearch';
import { useSecureState } from '../../Hooks/useSecureState';
import { useSidebarSelector } from '../../Hooks/useSidebar';
import { useUserSelector } from '../../Hooks/useUser';
import MailIcon from '../../Icons/Mail';
import BadgeAvatar from '../../common/BadgeAvatar';
import { BadgedIcon } from '../../common/CountBadge';
import APP_BREAKPOINTS from '../../styles/breakpoints';
import { palette } from '../../styles/colors';
import shape from '../../styles/shape';
import { COMPONENT_HEIGHTS, EXPANDED_MOBILE_SEARCH_HEIGHT } from '../../theme';
import AlertTooltips from '../AlertTooltips';
import InputSearch from '../InputSearch';
import HeaderAlerts from '../Popovers/HeaderAlerts';
import ModelCountPill from '../Popovers/ModelCountPill';
import "./Header.linaria.module.css!=!./Header?./Header.linaria.module.css?css=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"
const headerStyles = "atm_9s_1txwivl atm_h_1h6ojuz atm_vy_1osqo2v atm_cb_1wugsn5 atm_mk_h2mmj6 atm_c8_dlk8xv atm_lo_idpfg4 atm_le_idpfg4 atm_lk_ftgil2 atm_ll_ftgil2";
const compactHeaderStyles = "atm_lo_idpfg4 atm_le_idpfg4 atm_lk_1y44olf atm_ll_1y44olf";
const rootHeaderStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_h_1h6ojuz atm_fc_1y6m0gg atm_vy_1osqo2v";
const logoStyles = "atm_e2_dlk8xv atm_h3_t94yts atm_gz_idpfg4 atm_am_1pywi5l atm_jb_idpfg4 atm_jp_1dfr4pj atm_jr_1e5hqsa atm_9j_tlke0l atm_1tb8rw4_exct8b atm_thsoin_dlk8xv atm_1iz9m36_w1gvyb atm_1mxyq40_1fwxnve atm_bc7338_1skhajo atm_7faa42_19bvopo";
const searchContainerStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_fc_1h6ojuz atm_h_1h6ojuz atm_e2_1ady9kd atm_j6_1ady9kd atm_vy_1osqo2v atm_lo_idpfg4 atm_le_idpfg4 atm_lk_ftgil2 atm_ll_ftgil2";
const accountContainerStyles = "atm_9s_1txwivl atm_ar_vrvcex atm_be_1q9ccgz atm_am_glywfm atm_h_1h6ojuz atm_fc_usich2 atm_171oprq_1e5hqsa";
const buttonContainerStyles = "atm_9s_1txwivl atm_ar_vrvcex atm_be_1q9ccgz atm_am_glywfm atm_h_1h6ojuz atm_fc_1e5hqsa atm_171oprq_usich2 atm_zx4p8q_qhs3hr atm_dp1bdm_qhs3hr atm_1k92e5j_zktwlc atm_l78lkb_zktwlc atm_t9dqdl_vpnn4n atm_1og61z0_vpnn4n";
const menuContainerStyles = "atm_9s_glywfm atm_gz_idpfg4 atm_h0_exct8b atm_83s39l_1ulexfb";

/* CSS START: THIS BLOCK NEEDS TO BE IN THIS ORDER> */
export const textStyles = "atm_g3_bs82vp atm_9j_tlke0l atm_cs_ni7l0g atm_c8_dlk8xv atm_x57y4n_1fwxnve";
const nameTokensContainerStyles = "atm_83s39l_1txwivl atm_cseepa_1bp4okc atm_70eyac_1q9ccgz atm_1ovvwwn_usich2 atm_1a82bny_ftgil2 atm_krva2p_ftgil2 atm_1qfikww_cjiytx";
/* CSS END: */

/* CSS START: THIS BLOCK NEEDS TO BE IN THIS ORDER> */
const sharedLinkAttributes = "atm_am_1wugsn5 atm_h_1y6m0gg atm_rd_glywfm";
const nameSpanStyles = "atm_7l_1o88h4c";
const tokenSpanStyles = "atm_7l_70nmbi atm_gz_ftgil2 atm_7gthy8_1fwxnve atm_1a82bny_idpfg4 atm_1szqp91_1y44olf atm_pgg0nz_8stvzk";
const responsiveSmallTextStyles = "atm_381a41_1skhajo atm_hixllt_19bvopo";
const responsiveCompactUsernameStyles = "atm_c8_rdoju8 atm_ng4b36_ftgil2 atm_xbwllr_1ebrlns";
const responsiveCompactTokenStyles = "atm_c8_19bvopo atm_ng4b36_rdoju8 atm_xbwllr_ftgil2";
const phoneNameStyles = "atm_c8_19bvopo atm_5magtl_rdoju8";
const phoneTokenStyles = "atm_c8_rdoju8 atm_5magtl_ftgil2";
/* CSS END: */

const unverifiedStyles = "atm_cd_1m30gqx atm_gz_1y44olf atm_cs_1nn1f8g atm_7gthy8_1fwxnve atm_1a82bny_idpfg4";
const loginButtonStyles = "atm_2d_1nxixhv atm_le_1y44olf atm_ll_1fwxnve atm_lk_1fwxnve atm_lo_1y44olf atm_gz_dlk8xv atm_7l_1638ien atm_h0_1y44olf atm_cs_ni7l0g atm_1s473yy_rwbglg";
const signupButtonStyles = "atm_le_1y44olf atm_ll_1fwxnve atm_lk_1fwxnve atm_lo_1y44olf atm_2d_1nxixhv atm_7l_1638ien atm_cs_ni7l0g atm_1s473yy_rwbglg";
const iconButtonStyles = "atm_lo_idpfg4 atm_le_idpfg4 atm_lk_idpfg4 atm_ll_idpfg4 atm_3f_idpfg4";
const searchIconStyles = "atm_7l_1jxnbgj";
const compactIconStyles = "atm_lo_t94yts atm_le_t94yts atm_lk_t94yts atm_ll_t94yts";
const modelCountStyles = "atm_gz_ftgil2 atm_h0_ftgil2";
const sidebarButtonStyles = "atm_gz_ftgil2";
const darkModeToggleStyles = "atm_gz_ftgil2";
const alertsLeadStyles = "atm_9s_1txwivl atm_ar_vrvcex atm_be_1q9ccgz atm_h_1h6ojuz atm_jb_idpfg4 atm_am_1pywi5l";
const alertsLeadPhoneStyles = "atm_gz_1wugsn5 atm_h0_yh40bf";
const alertsLeadDockedStyles = "atm_gz_1fwxnve atm_h0_1wugsn5";
const alertsLeadRightStyles = "atm_gz_1wugsn5 atm_h0_ftgil2";
const phoneNameTokensStyles = "atm_9s_1txwivl atm_ar_1bp4okc atm_be_1q9ccgz atm_h_esu3gu atm_r3_usich2 atm_g3_1btqaar atm_gz_1y44olf atm_h3_t94yts";
const ageCheckLinkStyles = "atm_7l_1nxixhv atm_r3_1h6ojuz atm_h0_t94yts atm_g3_19bvopo atm_cs_ni7l0g atm_h3_yh40bf atm_c8_19bvopo atm_9j_tlke0l atm_vy_o7oli7 atm_xynb6q_1trjqt9 atm_p8tnmm_ftgil2 atm_2v50ut_ftgil2 atm_135hsxl_grho7r atm_nh2941_1wugsn5 atm_krva2p_grho7r atm_pciml6_ftgil2 atm_17b7ofy_dlk8xv";
const stylesCompactLoginRegisterSection = cx(textStyles, "atm_9s_1txwivl");
const stylesActionButtons = "atm_70_sppva8 atm_2d_1nxixhv atm_7l_1638ien atm_3f_y3fn96 atm_fc_1h6ojuz atm_h_1h6ojuz atm_l8_hooyhf atm_5j_1y44olf atm_9s_1txwivl atm_h0_1y44olf atm_jb_1oqxp62 atm_c8_19bvopo";
const stylesSignupButton = cx(stylesActionButtons, "atm_h0_yh40bf");
const mailRootStyles = "atm_h0_i2wt44";
const mailCompactRootStyles = "atm_gz_yjp0fh";
const mailPhoneRootStyles = "atm_mk_h2mmj6 atm_tk_t94yts";
const mailIconStyles = "atm_9j_tlke0l";
const mailCompactIconStyles = "atm_9j_tlke0l atm_lk_grho7r";
const onLogin = () => openAuthenticationDrawer();
const onSignup = () => openSignupDrawer();
const onOpenAccount = () => openAccountDrawer();
const onPurchaseTokens = () => openTokensDrawer();
const onToggleSidebar = () => {
  // update the window content size
  toggleSidebarVisibility();
  setScreenOrientation({
    overrideSkip: true
  });
};
interface LogoProps {
  darkMode: boolean;
  ageGateActive: boolean;
}
const Logo = ({
  darkMode,
  ageGateActive
}: LogoProps) => {
  const onClick = e => {
    e.preventDefault();
    if (ageGateActive) return;
    if (AppRouter.route.visibleRoute === '/') {
      const modelGrid = document.querySelector('.live-preview-grid');
      if (modelGrid) {
        modelGrid.scroll(0, 0);
      }
    } else {
      routerPush('/');
    }
  };
  return <img className={logoStyles} alt="MyFreeCams.com" onClick={onClick} src={!darkMode ? '/static/mfc-app-logo-green-transparent-bg.svg' : '/static/mfc-app-logo-white.svg'} />;
};
const Mail = ({
  compactHeader,
  phone
}) => {
  const anchorEl = useRef(null);
  const route = useRouteSelector('visiblePage');
  const isMail = route === 'mail';
  const unreadMailCount = useMailStateSelector('unread');
  // const windowWidth = useScreenStateSelector('windowWidth')

  const onClick = () => {
    goToMail();
  };
  const title = unreadMailCount > 0 ? `${unreadMailCount} unread MFC Mail message` : 'MFC Mail';
  return <div className={cx(!compactHeader ? mailRootStyles : mailCompactRootStyles, phone && mailPhoneRootStyles)} title={title}>
            <IconButton allowOverflow ref={anchorEl} onClick={onClick}>
                <BadgedIcon circular count={unreadMailCount} size="medium">
                    <MailIcon filled={isMail} size={!compactHeader ? '1.7rem' : 1} className={!compactHeader ? mailIconStyles : mailCompactIconStyles} />
                </BadgedIcon>
            </IconButton>
        </div>;
};
interface MobileSearchButtonProps {
  authenticated: boolean;
  onToggleSearchMobile;
}
const MobileSearchButton = (props: MobileSearchButtonProps) => {
  const {
    authenticated,
    onToggleSearchMobile
  } = props;
  return <IconButton style={authenticated ? {} : {
    marginRight: 6
  }} onClick={onToggleSearchMobile} className={iconButtonStyles}>
            <Icon path={mdiMagnify} size={1} className={searchIconStyles} data-testid="SearchIcon" />
        </IconButton>;
};
interface ActionContainerProps {
  ageGateActive: boolean;
  authenticated: boolean;
  compactHeader: boolean;
  expandSearch: boolean;
  hideDueToAgeGate: boolean;
  isBasicOrHigher: boolean;
  isiOSMobilePWALandscape: boolean;
  isMobile: boolean;
  isModel: boolean;
  isPremium: boolean;
  isSearchPage: boolean;
  page: string;
  phone: boolean;
  requiresAccountChange: boolean;
  uid: number;
  unverified: boolean;
  onClear(): void;
  onToggleSearch(): void;
  onToggleSearchMobile(): void;
  openAgeGateModal(): void;
}
const ActionsContainer = (props: ActionContainerProps) => {
  const {
    ageGateActive,
    authenticated,
    compactHeader,
    expandSearch,
    hideDueToAgeGate,
    isBasicOrHigher,
    isiOSMobilePWALandscape,
    isMobile,
    isModel,
    isPremium,
    isSearchPage,
    page,
    phone,
    requiresAccountChange,
    uid,
    unverified,
    onClear,
    onToggleSearch,
    onToggleSearchMobile,
    openAgeGateModal
  } = props;
  return <div className={buttonContainerStyles} data-testid="Header__ActionsContainer">
            {ageGateActive && !unverified && <span data-testid="Header__VerifyAgeLink" onClick={openAgeGateModal} className={ageCheckLinkStyles}>
                    Age Verification Required
                </span>}
            {compactHeader && !ageGateActive && !isiOSMobilePWALandscape && !isSearchPage && !unverified && !requiresAccountChange && <MobileSearchButton authenticated={authenticated} onToggleSearchMobile={onToggleSearchMobile} />}
            {!compactHeader && !ageGateActive && !isSearchPage && !expandSearch && !unverified && !requiresAccountChange && <IconButton onClick={onToggleSearch} title="Search">
                        <Icon path={mdiMagnify} size={1} className={cx(searchIconStyles, compactHeader && compactIconStyles)} data-testid="SearchIcon" />
                    </IconButton>}
            {!compactHeader && !hideDueToAgeGate && !isSearchPage && expandSearch && <HeaderSearch onInputSearchChange={headerSearch} onClear={onClear} page={page} />}
            {!compactHeader && !requiresAccountChange && !unverified && !hideDueToAgeGate && <div className={modelCountStyles}>
                        <ModelCountPill onClear={onClear} />
                    </div>}
            {!compactHeader && !isModel && isBasicOrHigher && <ButtonBuy disabled={ageGateActive || requiresAccountChange} />}
            {!compactHeader && <DarkModeToggle container="header" styleOverrides={darkModeToggleStyles} />}
            {!ageGateActive && !requiresAccountChange && !unverified && authenticated && isPremium && <ButtonUserBroadcast compact={isiOSMobilePWALandscape} compactIcon={compactHeader} semiCompact={isMobile} uid={uid} header />}
            {!ageGateActive && !requiresAccountChange && !unverified && authenticated && !phone && <HeaderAlerts compactHeader={compactHeader} />}
            {!ageGateActive && !requiresAccountChange && !unverified && authenticated && <Mail compactHeader={compactHeader} phone={phone} />}
        </div>;
};
interface SidebarToggleProps {
  authenticated: boolean;
  compactHeader: boolean;
  hideDueToAgeGate: boolean;
  isSidebarOpen: boolean;
  requiresAccountChange: boolean;
  unverified: boolean;
}
const SidebarToggle = ({
  authenticated,
  compactHeader,
  hideDueToAgeGate,
  isSidebarOpen,
  requiresAccountChange,
  unverified
}: SidebarToggleProps) => <div className={buttonContainerStyles} data-testid="Sidebar__Toggle">
        {!hideDueToAgeGate && !requiresAccountChange && !unverified && !compactHeader && <ButtonSidebar title={isSidebarOpen ? locales.header.closeSidebar : locales.header.openSidebar} data-testid={`IconButton__FriendsToggle${isSidebarOpen ? 'Open' : 'Close'}`} onClick={onToggleSidebar} overrides={!authenticated && sidebarButtonStyles} opened={isSidebarOpen} />}
    </div>;
interface AccountProps {
  ageGateActive: boolean;
  authenticated: boolean;
  compactHeader: boolean;
  delayedTokens;
  hideDueToAgeGate: boolean;
  isModel: boolean;
  phone: boolean;
  requiresAccountChange: boolean;
  uid: number;
  unverified: boolean;
  username: string;
}
const Account = (props: AccountProps) => {
  const {
    ageGateActive,
    authenticated,
    delayedTokens,
    uid,
    compactHeader,
    hideDueToAgeGate,
    isModel,
    phone,
    requiresAccountChange,
    unverified,
    username
  } = props;
  const UserInfoSection = <>
            <div className={cx(textStyles, phone ? phoneNameTokensStyles : nameTokensContainerStyles)} data-testid="Header__UsernameTypography">
                <span onClick={hideDueToAgeGate || requiresAccountChange || unverified ? () => {} : onOpenAccount} title={locales.header.openMenu} className={cx(nameSpanStyles, !phone && responsiveSmallTextStyles, !phone && compactHeader && username?.length >= 14 ? responsiveCompactUsernameStyles : null, phone && phoneNameStyles)}>
                    {username}
                </span>
                {!unverified && !ageGateActive && !requiresAccountChange && authenticated && !isModel && <span data-testid="Header__TokensCount" onClick={ageGateActive ? () => {} : onPurchaseTokens} className={cx(tokenSpanStyles, sharedLinkAttributes, !phone && responsiveSmallTextStyles, 'mfc-age-gate', !phone && compactHeader && username?.length >= 14 && delayedTokens >= 100 ? responsiveCompactTokenStyles : null, phone && phoneTokenStyles)} title={locales.header.purchaseTokens}>
                            {delayedTokens ?? ''} {locales.header.tokens}
                        </span>}
                {unverified && <span className={cx(sharedLinkAttributes, responsiveSmallTextStyles, unverifiedStyles)} data-testid="Header__UnverifiedAccount">
                        (Unverified Account)
                    </span>}
            </div>
            {!compactHeader && <BadgeAvatar id={uid} isOffline={false} disableBadge={true} isBroadcasting={false} addBoxShadow={true} onClick={hideDueToAgeGate || requiresAccountChange || unverified ? () => {} : onOpenAccount} title={locales.header.openMenu} size={COMPONENT_HEIGHTS.headerDesktop - 10} />}
        </>;
  const CompactLoginRegisterSection = <div className={stylesCompactLoginRegisterSection} data-testid="Header__UsernameTypography">
            <div data-testid="Header__LoginButton" onClick={onLogin} className={stylesActionButtons} style={ageGateActive && !unverified ? {
      minWidth: 'auto'
    } : null}>
                {locales.header.login}
            </div>
            <div data-testid="Header__RegisterButton" onClick={onSignup} className={stylesSignupButton}>
                {locales.header.freeAccount}
            </div>
        </div>;
  const LoginRegisterSection = <div className={textStyles} data-testid="Header__UsernameTypography">
            <Button data-testid="Header__LoginButton" onClick={onLogin} title={locales.header.login} className={loginButtonStyles} size="small" border clean>
                {locales.header.login}
            </Button>
            <Button data-testid="Header__RegisterButton" onClick={onSignup} title={locales.header.freeAccountVerbose} className={signupButtonStyles} size="small" border clean>
                {locales.header.freeAccountVerbose}
            </Button>
        </div>;
  return <div className={accountContainerStyles}>
            {authenticated ? UserInfoSection : compactHeader ? CompactLoginRegisterSection : LoginRegisterSection}
        </div>;
};
interface HeaderSearchProps {
  onInputSearchChange(query?: string): void;
  onClear(): void;
  mobile?: boolean;
  page: string;
}
const HeaderSearch = (props: HeaderSearchProps) => {
  const {
    onInputSearchChange,
    onClear,
    mobile,
    page
  } = props;
  const isHomePage = page === '';
  const {
    query: searchQuery
  } = useSearch();
  const {
    search: stateSearchQuery,
    external
  } = searchQuery;
  const searchInputRef = useRef(null);
  const onInputRefCallback = ref => {
    searchInputRef.current = ref;
  };
  useEffect(() => {
    if (!external) {
      return;
    }
    searchInputRef.current.value = stateSearchQuery;
    deleteSearchQueryExternal();
  }, [external]);
  return <div data-testid="StyledInputSearchContainer" style={{
    flex: mobile ? 0 : '0 1 265px',
    maxHeight: '100%',
    marginLeft: mobile ? 0 : 2,
    background: palette.headerBackground,
    width: mobile ? '100%' : 'auto'
  }}>
            <InputSearch page={page} autoFocus={true} debounce={true} debounceDelay={isHomePage ? 325 : 500} disableHistoryPopover={false} defaultValue={''} onInputRef={onInputRefCallback} placeholder={locales.header.search} historyMax={MAX_SEARCH_QUERIES_STORED} onChange={onInputSearchChange} onClear={onClear} quietFocus style={{
      borderRadius: shape.borderRadius
    }} />
        </div>;
};
interface HeaderProps {
  authenticated: boolean;
  darkMode: boolean;
  isMobile: boolean;
  level: number;
  showMenu: boolean;
  uid: number;
  username: string;
  vertical: boolean;
}
const Header = (props: HeaderProps) => {
  const {
    showMenu,
    vertical
  } = props;
  const {
    authenticated = props.authenticated,
    darkMode = props.darkMode,
    isMobile = props.isMobile,
    unverified,
    requiresAccountChange
  } = useAppState(AppStateType.APP);
  const tokens = useUserSelector('me', 'tokens');
  const username = useUserSelector('me', 'name') || props.username;
  const level = useUserSelector('me', 'level') || props.level;
  const uid = useUserSelector('me', 'id') || props.uid;
  const {
    ageGateActive
  } = useSecureState(SecureStateType.AGE_VERIFICATION);
  const displayConfig = useSecureState(SecureStateType.DISPLAY_CONFIG);
  const hideDueToAgeGate = ageGateActive && displayConfig?.settings === GatedDisplayModes.hideEverything;
  const [expandSearch, setExpandSearch] = useState(false);
  const [compactHeader, setCompactHeader] = useState(isMobile);
  const [phoneHeader, setPhoneHeader] = useState(isMobile);
  const [isiOSMobilePWALandscape, setIsiOSMobilePWALandscape] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(); // so SSR and client renders match
  const [isDarkMode, setIsDarkMode] = useState<boolean>(); // so SSR and client renders match
  const expandedNav = useLayoutSelector('expandedNav');
  const expandedSearchMobile = useLayoutSelector('expandedSearchMobile');
  const page = useRouteSelector('visiblePage');
  const isSearchPage = page === 'search';
  useEffect(() => {
    setExpandSearch(false);
    updateLayoutState({
      expandedSearchMobile: false
    });
  }, [page]);
  const windowWidth = useScreenStateSelector('windowWidth');
  const smallViewport = windowWidth > 0 ? windowWidth < APP_BREAKPOINTS.md : isMobile;
  const phoneViewport = windowWidth > 0 ? windowWidth < APP_BREAKPOINTS.sm : isMobile;
  const stackAlerts = phoneHeader || !compactHeader && expandSearch && windowWidth < APP_BREAKPOINTS.lg;
  const expanded = expandedSearchMobile;
  const headerHeight = compactHeader ? COMPONENT_HEIGHTS.headerCompact : COMPONENT_HEIGHTS.headerDesktop;
  const height = headerHeight + (expanded ? EXPANDED_MOBILE_SEARCH_HEIGHT : 0);

  // set the correct state in the first render (client side)
  useEffect(() => {
    setIsDarkMode(darkMode);
  }, [darkMode]);

  // set the correct state in the first render (client side)
  useEffect(() => {
    setCompactHeader(smallViewport);
  }, [smallViewport]);
  useEffect(() => {
    setPhoneHeader(phoneViewport);
  }, [phoneViewport]);
  const sidebarOpen = useSidebarSelector('show');

  // set the correct state in the first render (client side)
  useEffect(() => {
    setIsSidebarOpen(sidebarOpen);
  }, [sidebarOpen]);

  // , {
  //     // this should probably be handled here so we can convert the hook otherwise
  //     ssrCompatible: true,
  // })
  const [delayedTokens, setTokens] = useState(null);
  useEffect(() => {
    // let the first render have blank tokens so it matches ssr
    setTokens(tokens);
  }, [tokens]);
  useEffect(() => {
    setIsiOSMobilePWALandscape(isPWA && isIDevice && compactHeader && !vertical);
  }, [compactHeader, vertical]);
  const isModel = isLevelModel(level);
  const isPremium = isLevelPremium(level);
  const isBasicOrHigher = isLevelBasicOrHigher(level);
  const onExpandNav = () => {
    transitionNavLayout(expandedNav);
  };
  const onToggleSearch = () => setExpandSearch(val => !val);
  const onToggleSearchMobile = () => {
    updateLayoutState({
      expandedSearchMobile: !expandedSearchMobile
    });
  };
  const onClear = () => {
    setExpandSearch(false);
    updateLayoutState({
      expandedSearchMobile: false
    });
    resetSearchQuery();
    resetSearchResults();
  };
  const openAgeGateModal = () => {
    openAgeGateDialog(displayConfig?.settings);
  };
  return <div className={rootHeaderStyles} style={{
    ...(isiOSMobilePWALandscape ? {
      paddingLeft: 58,
      paddingRight: 36
    } : null),
    height: height,
    minHeight: height
  }}>
            <header className={cx(headerStyles, compactHeader ? compactHeaderStyles : null)} style={{
      justifyContent: compactHeader ? 'flex-end' : 'space-between',
      height: headerHeight,
      minHeight: headerHeight,
      backgroundColor: isMobile ? palette.background : null
    }}>
                {!compactHeader && showMenu && <div className={menuContainerStyles}>
                        <ButtonMenu onClick={hideDueToAgeGate ? () => {} : onExpandNav} />
                    </div>}
                <Logo darkMode={isDarkMode} ageGateActive={hideDueToAgeGate} />
                <div className={cx(alertsLeadStyles, phoneHeader ? alertsLeadPhoneStyles : stackAlerts ? alertsLeadRightStyles : alertsLeadDockedStyles)} data-testid="Header__AlertsLead">
                    {!ageGateActive && !requiresAccountChange && !unverified && authenticated && stackAlerts && <HeaderAlerts compactHeader={compactHeader} stack stackOnly={!phoneHeader} />}
                    {authenticated && <AlertTooltips compact={compactHeader} stack={stackAlerts} />}
                </div>
                <ActionsContainer ageGateActive={ageGateActive} authenticated={authenticated} compactHeader={compactHeader} expandSearch={expandSearch} hideDueToAgeGate={hideDueToAgeGate} isBasicOrHigher={isBasicOrHigher} isiOSMobilePWALandscape={isiOSMobilePWALandscape} isMobile={isMobile} isModel={isModel} isPremium={isPremium} isSearchPage={isSearchPage} page={page} phone={phoneHeader} requiresAccountChange={requiresAccountChange} uid={uid} unverified={unverified} onClear={onClear} onToggleSearch={onToggleSearch} onToggleSearchMobile={onToggleSearchMobile} openAgeGateModal={openAgeGateModal} />
                <Account ageGateActive={ageGateActive} authenticated={authenticated} compactHeader={compactHeader} delayedTokens={delayedTokens} hideDueToAgeGate={hideDueToAgeGate} isModel={isModel} phone={phoneHeader} requiresAccountChange={requiresAccountChange} uid={uid} unverified={unverified} username={username} />
                <SidebarToggle authenticated={authenticated} compactHeader={compactHeader} hideDueToAgeGate={hideDueToAgeGate} isSidebarOpen={isSidebarOpen} requiresAccountChange={requiresAccountChange} unverified={unverified} />
            </header>
            {expandedSearchMobile && <div className={cx('mfc-age-gate', searchContainerStyles)}>
                    <HeaderSearch onInputSearchChange={headerSearch} onClear={onClear} page={page} mobile />
                </div>}
        </div>;
};
export default Header;